import { useState } from 'react'

import { useSaveSettings, useSettings } from '../../hooks/queries'
import { ausEinstellungen, type Listensatz } from '../../lib/listenfarben'
import { Listenwahl } from './Listenwahl'

/**
 * Die **Voreinstellung** für die Farben der Reiseübersicht (#54).
 *
 * Aus dem Betrieb: „Admin stellt ein für alle, einzelne können überschreiben."
 * Diese Karte steht deshalb in der Verwaltung; die Karte daneben
 * (`Listenfarben`) steht bei jedem und gewinnt, solange dort etwas steht.
 *
 * **Und die Frage aus dem Issue ist beantwortet:** „wie geht das bei 2
 * Admins?" — es gibt genau *eine* Voreinstellung. Wer Verwaltung ist,
 * bearbeitet denselben Wert; zwei Admins sind zwei Hände am selben Regler,
 * keine zwei Regler.
 */
export function ListenfarbenCard() {
  const settings = useSettings()
  const save = useSaveSettings()
  const [gemeldet, setGemeldet] = useState(false)

  const daten = settings.data
  // Ohne Decke ist dieses Konto keine Verwaltung -- der Server hat entschieden.
  if (!daten?.ceiling) return null

  return (
    <div className="card card--seite">
      <h2 className="card__titel">Farben der Reiseübersicht</h2>
      <Listenwahl
        lead="Die Voreinstellung für alle. Wer für sich etwas anderes einstellt, sieht seins — diese Farben gelten dann für ihn nicht mehr."
        werte={ausEinstellungen(daten.settings)}
        leerText="Automatisch"
        alleText="Alles automatisch"
        laeuft={save.isPending}
        fehler={
          save.isError
            ? save.error instanceof Error
              ? save.error.message
              : 'Das hat nicht geklappt.'
            : null
        }
        gemeldet={gemeldet}
        onSpeichern={async (satz: Listensatz) => {
          setGemeldet(false)
          await save.mutateAsync({
            list_own_color: satz.own,
            list_other_color: satz.other,
            list_bg_color: satz.bg,
          })
          setGemeldet(true)
        }}
      />
    </div>
  )
}
